<div class="title-container">
  <h5 class="text-uppercase title mb-0">{{ title }}</h5>
  <h6 *ngIf="subtitle" class="subtitle">{{ subtitle }}</h6>
</div>
